import { render, staticRenderFns } from "./AccessionInsurance.vue?vue&type=template&id=05fe59e8&scoped=true&"
import script from "./AccessionInsurance.vue?vue&type=script&lang=js&"
export * from "./AccessionInsurance.vue?vue&type=script&lang=js&"
import style0 from "./AccessionInsurance.vue?vue&type=style&index=0&id=05fe59e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fe59e8",
  null
  
)

export default component.exports